class ScheduleController {

    constructor() {
        this.calendarController = new ScheduleCalendarController();
        this.summaryController = new ScheduleSummaryController();
        this.saveController = new ScheduleSaveController();
        this.shareController = new ScheduleShareController();
        this.helpController = new HelpController();
        this.printController = new PrintController();
    }

    populate(schedule) {
        this.calendarController.populate(schedule);
        this.summaryController.update(schedule);
    }

}
